import { useDispatch, useSelector } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import { DemoDisabledTooltip } from "app/pages/sales-intelligence/common-components/demo-mode/DemoDisabledTooltip";
import {
    selectIsShowSavedSearchListPanel,
    setIsOpenListPanel,
} from "app/pages/sales-intelligence/modules/leads-search";
import useSavedSearchesList from "app/pages/sales-intelligence/modules/lists/sub-modules/my-list/queries/useSavedSearchsList";
import { useIsDemoMode } from "app/pages/sales-intelligence/store/demo-mode/useDemoModeStore";

import { SavedSearchesOverlayToggle } from "../../components/SavedSearchesOverlayToggle";
import { SavedSearchPanel } from "../../components/SavedSearchPanel/SavedSearchPanel";

const SavedSearchPanelContainer = () => {
    const dispatch = useDispatch();
    const isShowListPanel = useSelector(selectIsShowSavedSearchListPanel);
    const isDemoMode = useIsDemoMode();

    const { data, isLoading, setSearchText, searchText, refetch } = useSavedSearchesList();

    const handleOnClose = () => {
        setSearchText("");
        dispatch(setIsOpenListPanel(false));
    };

    return (
        <div>
            {data?.totalCount || (!data?.totalCount && searchText) ? (
                <DemoDisabledTooltip>
                    <SavedSearchesOverlayToggle
                        count={data?.totalCount}
                        isDisabled={isDemoMode}
                        onClick={() => dispatch(setIsOpenListPanel(true))}
                    />
                </DemoDisabledTooltip>
            ) : null}

            <SavedSearchPanel
                isOpen={isShowListPanel}
                onClose={handleOnClose}
                title={translate("si.advanced_search.my-saved-searches.title")}
                saveSearches={data?.records || []}
                totalCount={data?.totalCount || 0}
                onRefetch={refetch}
                searchText={searchText}
                setSearchText={setSearchText}
                isLoading={isLoading}
            />
        </div>
    );
};

export default SavedSearchPanelContainer;
